// import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { LOGIN, STORE_MENU } from 'store/actions';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';

// material-ui
import { Box, Grid, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// form
import { useForm, FormProvider } from 'react-hook-form';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';
import { useYupValidationResolver, TextInput } from '@qubiteq/qublib';
import { ForgotPasswordModal, useOpenModal } from '../forgotPassword';

// Apis
import { auth } from 'apis';

import { useTranslation } from 'react-i18next';

import { useLoginValidation } from 'utils/validation/login-form';

// ============================|| LOGIN ||============================ //

const defaultValues = {
    username: '',
    password: ''
};

const Login = () => {
    const { open, toggle } = useOpenModal();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const validationSchema = useLoginValidation();
    // const memomizedValidation = useMemo(validationSchema, []);
    const resolver = useYupValidationResolver(validationSchema);
    const { t } = useTranslation();
    const methods = useForm({
        resolver,
        defaultValues,
        mode: 'onSubmit',
        reValidateMode: 'onBlur'
    });
    const { enqueueSnackbar } = useSnackbar();
    const onSubmit = async (data) => {
        await auth
            .login({
                username: data.email,
                password: data.password
            })
            .then((res) => {
                console.log('login payload', res);
                dispatch({ type: STORE_MENU, menuItems: res?.menu });
                dispatch({ type: LOGIN, payload: res });
                enqueueSnackbar(t('LoginSuccess'), {
                    variant: 'success'
                });
                navigate('/home');
            })
            .catch((error) => {
                console.log('error', error);
                enqueueSnackbar(error?.data?.message || t('SomethingWrong'), {
                    variant: 'error'
                });
            });
    };

    return (
        <FormProvider {...methods}>
            <ForgotPasswordModal open={open} toggle={toggle} />
            <form>
                <Grid container direction="column" justifyContent="center" spacing={2}>
                    <Grid item xs={12} container alignItems="center" justifyContent="center">
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle1">{t('LoginEmailUsername')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <TextInput id="email" name="email" placeholder={t('Email')} size="medium" />
                    </Grid>
                    <Grid item xs={12}>
                        <TextInput id="password" name="password" placeholder={t('Password')} size="medium" type="password" />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            variant="subtitle1"
                            color="secondary"
                            onClick={toggle}
                            sx={{
                                textDecoration: 'none',
                                cursor: 'pointer'
                            }}
                        >
                            {t('ForgotPassword')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <AnimateButton>
                            {/* eslint-disable */}
                            <LoadingButton
                                loading={methods.formState.isSubmitting}
                                disableElevation
                                fullWidth
                                size="large"
                                variant="contained"
                                type="submit"
                                onClick={methods.handleSubmit(onSubmit)}
                            >
                                {t('Login')}
                            </LoadingButton>
                        </AnimateButton>
                    </Grid>
                </Grid>
            </form>
        </FormProvider>
    );
};

export default Login;
